import React, { useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { ShopperContext } from '../context/shopper';
import { useStyles } from "../hooks/useStyles";
import { usePhrasing, useLookups } from "../hooks/useSkuUtils";
import Table from 'react-bootstrap/Table';
import { useTranslation } from "react-i18next";
import * as Constants from '../constants';
import HeadingBuilder from '../components/HeadingBuilder';
import { BackButton } from '../components/BackButton';
import { TermsPrivacyUrls } from '../components/pieces/TermsPrivacyUrls';
import styles from '../css/trTdFirstChild.module.css';

// TODO: clean up "location" stuff.
// This is the page we will open from a list of CircleShoppers to view/edit shopper's info
const Shopper = () => {
  const { shopper, fetchShopper,
    circleShoppers, signedIn} = useContext(ShopperContext);

  console.log('sjs shopper: ', shopper)

  //const location = useLocation();
  //console.log('shopper_loc_state', location.state);
  //const { shopper_name, admin_status, identifier, cshopper_id } = location.state;

  const [ttsRowsFlag, setTtsRowsFlag] = useState(false);
  const showTheTtsRows = () => { setTtsRowsFlag(true)  }
  const hideTheTtsRows = () => { setTtsRowsFlag(false) }

  const { tableShow, tableData } = useStyles();
  const { t } = useTranslation();

  const {
    getShowTippyHelpIconLabel,
    getShowTooltipsTippy,
    getShowTooltipsTippyAudio,
    getShowVideoTipsTippy,
    getShowVideoTipsTippyAudio,
    getShopperShortnameTippyText,
    getShopperShortnameTippyAudio,
  } = usePhrasing();

  const { lookup_voice_label } = useLookups();

  const {id} = useParams();
  console.log('Shopper.js id: ', id)

  // TODO: This isn't working. Wonder why.
  // Don't see ill effect so I'm leaving active, but adding this only as a
  // comment in App.js:
  // <Route path="/shoppers" element={<Home />} />
  //
  // This logic from Trip.js (see comments there.)
  const navigate = useNavigate();
  //if (circleShoppers.length === 0)
  //if (shopper.length === 0)
  //if (shopper.id === undefined) 
  // https://bobbyhadz.com/blog/javascript-check-if-object-is-empty
  if (Object.keys(shopper).length == 0) {
    // This log message shows up:
    console.log('Shopper.js Im here: ')

    // Let's go back to the 'home' page, '/',
    // but 'navigate' has no effect, no matter where I direct it:
    // navigate('/')
    // window.location.replace('/');
  }

  const refreshShopper = (e) => {
    e.preventDefault();
    async function getShopper() {
      try {
        await fetchShopper();
        navigate(`/shoppers/${shopper.id}`)
      } catch (error) {
        console.error(error);
      }
    }
    getShopper();
  }

  const showTippyHelpIconLabel     = getShowTippyHelpIconLabel();

  const showTooltipsTippy          = getShowTooltipsTippy();
  const showTooltipsTippyAudio     = getShowTooltipsTippyAudio();

  const showVideoTipsTippy         = getShowVideoTipsTippy();
  const showVideoTipsTippyAudio    = getShowVideoTipsTippyAudio();

  const shopperShortnameTippyText  = getShopperShortnameTippyText();
  const shopperShortnameTippyAudio = getShopperShortnameTippyAudio();

  // Does 'id' belong to the shopper or a circleShopper? Else it's invalid.
  const shopperIsSelf =   shopper.id == id  ? shopper : null;

  const circleShopperIsOther =
    shopperIsSelf
      ? null
      : circleShoppers.find( (cs) =>  cs.shopper_id == id )
        // TODO: get warning for '==', but '===' fails - quiesce?

  const aShopper = shopperIsSelf ||
    (circleShopperIsOther  ? circleShopperIsOther.shopper : {});
  console.log('sjs aShopper: ', aShopper)


  const shopperProfileHeadineValue =
    aShopper.id
      ? aShopper.shortname
      : '(' + t('global.label.notFound') + ')';

  const otherShopperEmail =
    aShopper.id
      ? '(' + t('global.label.hiddenForNow') + ')'
      : "";

  const helpVoice =
    aShopper.help_voice
      ? aShopper.help_voice
      : Constants.TIPPY_HELP_VOICE;
      // google_en_us_female

  const ttsRate =
    aShopper.tts_rate
      ? aShopper.tts_rate
      : Constants.TIPPY_TTS_RATE;  // 1

  if (signedIn) {

  return (
    <article>
      <HeadingBuilder
        Size           = 'h3'
        headingText    = {t('shopper.formPart.shopperProfileHeadlineLabel')}
        value          = {shopperProfileHeadineValue}
                       // Shopper Profile: newguy
      />
      <Table responsive striped bordered hover size="sm" style={tableShow}>
        <thead>
        </thead>
        <tbody className={styles.trTdFC} style={tableData} >
          <tr>
            <td>
              {/* Username */}
              { t('global.label.username') }
            </td>
            <td>
              {aShopper.identifier}
            </td>
          </tr>
          <tr>
            <td>
              {/* First name */}
              {t('shopper.firstname.label')}
            </td>
            <td>
              {aShopper.firstname}
            </td>
          </tr>
          <tr>
            <td>
              {/* Last name */}
              {t('shopper.lastname.label')}
            </td>
            <td>
              {aShopper.lastname}
            </td>
          </tr>
          <tr>
            <td>
              <HeadingBuilder
                containerType='container-input-label'
                headingText = {t('shopper.shortname.label')}
                // Short name
                tippyAlertText = {shopperShortnameTippyText}
                tippyText      = {shopperShortnameTippyText}
                tippyAlertAudio= {shopperShortnameTippyAudio}
              />
            </td>
            <td>
              {aShopper.shortname}
            </td>
          </tr>
          <tr>
            <td>
              {/* Email */}
              {t('shopper.email.label')}
            </td>
            <td>
  {/* {aShopper.email} - present this in a masked fashion? enable messaging? */}
              {
            shopper.id == aShopper.id
              ?
                // 'shopper.unconfirmed_email' won't usually have a value,
                // so it will be rare that we show the 'refresh' button for Email
                (shopper.unconfirmed_email != undefined  &&
                 shopper.unconfirmed_email.length > 0)
                  ? <HeadingBuilder
                      containerType='container-input-label-left'
                      headingText = {
                        shopper.id == aShopper.id
                          ? <span> {aShopper.email}</span>
                          : <span> {otherShopperEmail}</span>
                      }
                      bgroundColor   = {Constants.LIGHT_RED}
                      buttonAction   = {refreshShopper}
                      goButtonText   = {Constants.GET_ICON_REFRESH}
                      tippyAlertText = {t('shopper.email.noteAboutRefresh')}
                      tippyText      = {t('shopper.email.noteAboutRefresh')}
                    />
                  : <span> {aShopper.email}</span>
              : <span> {otherShopperEmail}</span>
              }
            </td>
          </tr>
        { false
          ?
          <tr>
            <td>
              {/* Zip Code */}
              {t('shopper.postal_code.label')}
            </td>
            <td>
              {aShopper.postal_code}
            </td>
          </tr>
          : null
        }
    { shopper.id == id
      ? <>
          <tr>
            <td>
              {/* Settings: */}
              <em>{t('shopper.settings.label')}</em>
            </td>
            <td>
              {null}
            </td>
          </tr>
          <tr>
            <td>
              <HeadingBuilder
                containerType  = 'container-input-label'
                headingText    = {showTippyHelpIconLabel}
                // Show tooltips via [?] button
                tippyAlertText = {showTooltipsTippy}
                tippyText      = {showTooltipsTippy}
                tippyAlertAudio= {showTooltipsTippyAudio}
              />
            </td>
            <td>
              <HeadingBuilder
                containerType='container-left'
                headingText = {aShopper.show_tippy_help_alert_icons
                                ? t('global.label.yes')
                                : t('global.label.no')
                              }
              />
            </td>
          </tr>
          <tr>
            <td>
              <HeadingBuilder
                containerType='container-input-label'
                headingText = {t('shopper.showVideoTipsIcon.label')}
                // Show video tips
                tippyAlertText = {showVideoTipsTippy}
                tippyAlertAudio= {showVideoTipsTippyAudio}
                tippyText      = {showVideoTipsTippy}
              />
            </td>
            <td>
              <HeadingBuilder
                containerType='container-left'
                headingText = {aShopper.show_help_video_icons
                                ? t('global.label.yes')
                                : t('global.label.no')
                              }
              />
            </td>
          </tr>
          <tr>
            <td>
              <HeadingBuilder
                containerType  = 'container-input-label'
                headingText    = {t('tts.shopper.label')}
                // Help Text Voiceovers
                tippyAlertText ={t('tts.shopper.setupTtsCtlButtonTippyContent')}
                tippyText      = {Constants.DOT}
// You can control the voice and playback rate of help tips via these settings.
              />
            </td>
            <td>
              <>
              {ttsRowsFlag
                ? <HeadingBuilder
                    containerType  = 'container-left'
                    headingText    = {t('tts.shopper.ttsCtlButtonText', {
                              actionDataType: t('tts.shopper.dataTypeTextHide')
                                     })}
                    // STOP showing settings here for help text playback
                    buttonAction   = {hideTheTtsRows}
                    goButtonText   = {Constants.GET_ICON_RT_ARROW}
                    bgroundColor   = {Constants.LIGHT_BLUE}
                    tippyText      = {Constants.DOT}
                  />
                : <HeadingBuilder
                    containerType  = 'container-left'
                    headingText    = {t('tts.shopper.ttsCtlButtonText', {
                              actionDataType: t('tts.shopper.dataTypeTextShow')
                                     })}
                    // Show settings here for help text playback
                    buttonAction   = {showTheTtsRows}
                    goButtonText   = {Constants.GET_ICON_RT_ARROW}
                    tippyText      = {Constants.DOT}
                  />
              }
              </>
            </td>
          </tr>
        { ttsRowsFlag
        ? <>
          <tr>
            <td>
              <HeadingBuilder
                containerType  = 'container-input-label'
                headingText    = {t('tts.shopper.profileLabel')}
                // Name of Help Voice
                tippyAlertText = {t('tts.shopper.tippyContent',
                                        {preamble: t('tts.shopper.profile')} )}
                tippyText      = {Constants.DOT}
                // This is the voice that will read help tips for you...
              />
            </td>
            <td>
              <HeadingBuilder
                containerType  = 'container-left'
                bgroundColor   = {Constants.VERY_LIGHT_BLUE}
                headingText    = {lookup_voice_label({
                                    voice_term: helpVoice })}
                // English · United States · Google
              />
            </td>
          </tr>
          <tr>
            <td>
              <HeadingBuilder
                containerType  = 'container-input-label'
                headingText    = {t('tts.shopper.ttsRateLabel')}
                // Help Playback Speed
                labelHtmlFor   = "tts_rate_sef"
                tippyAlertText = {t('tts.shopper.ttsRateTippyContent', {
                  preamble: t('tts.shopper.ttsRatePreamble'),
                  postscript: ''
                })}
                tippyText      = {Constants.DOT}
                // A relative measure of the speed of audio playback of help tips. A value of '1.0' represents the standard playback rate.
              />
            </td>
            <td>
              <HeadingBuilder
                containerType  = 'container-left'
                bgroundColor   = {Constants.VERY_LIGHT_BLUE}
                headingText    = {parseFloat(ttsRate).toFixed(1)}
                // 1.0
              />
            </td>
          </tr>
          </>
        : null
        }
          <tr>
            <td>
              <HeadingBuilder
                containerType='container-input-label'
                headingText = {
                    t('shopper.mktgEmailOptin.label') 
                  + ' - '
                  + t('shopper.mktgEmailOptin.description')
                }
// Email Opt-in - Send me helpful advice, news, and exclusive offers (Optional).
                tippyAlertText = {t('shopper.mktgEmailOptin.tippyContent', {
                        takeAction: t('shopper.mktgEmailOptin.editYourProfile')
                                 })}
                tippyText      = {Constants.DOT}
  // Because we respect your inbox, we only send account-specific alerts by default. If you would like to receive newsletter updates, usage advice, and exclusive offers, edit your profile to opt-in.  
              />
            </td>
            <td>
              <HeadingBuilder
                containerType='container-left'
                headingText = {aShopper.mktg_email_optin
                                ? t('global.label.yes')
                                : t('global.label.no')
                              }
              />
            </td>
          </tr>
          <tr>
            <td>
              <HeadingBuilder
                containerType='container-input-label'
                headingText = {t('shopper.agreeTermsPrivacyA.label')}
                // I have read and agree to...
                tippyAlertText = {t('shopper.agreeTermsPrivacyA.termsPrivacy')}
                tippyText      = {t('shopper.agreeTermsPrivacyA.termsPrivacy')}
                // 'Terms' is the agreement between you and...
              />
            </td>
            <td>
              <HeadingBuilder
                containerType='container-left'
                headingText = {aShopper.agree_tos_pp_a
                                ? t('global.label.yes')
                                : t('global.label.no')
                              }
              />
              &nbsp; - &nbsp;
              <TermsPrivacyUrls />
            </td>
          </tr>
        </>
      : null
    }
        </tbody>
      </Table>
      {
        shopper.id == aShopper.id  &&
        <>
          <HeadingBuilder
            tippyAlertText = {t('shopper.changeProfileButton.tippyContent')}
            tippyText      = {t('shopper.changeProfileButton.tippyContent')}
            linkUrl        = {`/shoppers/${shopper.id}/edit`}
            goButtonText   = {Constants.GET_ICON_RT_ARROW}
            headingText    = {t('shopper.changeProfileButton.label')}
                           // Change Profile Details:
            value          = {aShopper.identifier}
          />
          <br/>
          <HeadingBuilder
            tippyAlertText = {t('shopper.deleteAccountButton.tippyContent')}
            tippyText      = {t('shopper.deleteAccountButton.tippyContent')}
            linkUrl        = {`/shoppers/${shopper.id}/delete`}
            headingText    = {t('shopper.deleteAccountButton.label')}
                           // Delete My Account
          />
        </>
      }
      <BackButton />
      {/* <BackButton whatToDo={resetSkuTypeFormFlags}/> */}
    </article>
  )
  } else {
    return (
      <HeadingBuilder
        Size = 'h3'
        headingText = {t('global.notSignedInMessage')}
        // Not Authorized - Please Sign in or Sign up
      />
    )
  }
}
export default Shopper